export { default as GOOGLE_MAPS_STYLES } from './map-styles';

const {
  wlApiSettings,
  wlCurrentTheme,
  googleMapsAPIKey,
  themeDirectoryURI
} = window;

export const GOOGLE_MAPS_API_KEY = googleMapsAPIKey ? googleMapsAPIKey[0] : '';
export const THEME_DIRECTORY_URI = themeDirectoryURI
  ? themeDirectoryURI[0]
  : '';

export const WL_API_URL = wlApiSettings.url;
export const WL_CURRENT_THEME = wlCurrentTheme ? wlCurrentTheme[0] : '';
